const typography = {
  BodyXsRegular: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 400,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodyXsSemibold: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodySmRegular: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodySmSemibold: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 600,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodyMdRegular: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodyMdSemibold: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 600,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodyLgRegular: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodyLgSemibold: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodyXlRegular: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 400,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  BodyXlSemibold: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 600,
    fontFamily: 'Inter',
  } as React.CSSProperties,
  HeadingXs: {
    fontSize: 16,
    lineHeight: '24px',
    fontFamily: 'Barlow',
  } as React.CSSProperties,
  HeadingSm: {
    fontSize: 18,
    lineHeight: '24px',
    fontFamily: 'Barlow',
  } as React.CSSProperties,
  HeadingMd: {
    fontSize: 24,
    lineHeight: '28px',
    fontFamily: 'Barlow',
  } as React.CSSProperties,
  HeadingLg: {
    fontSize: 32,
    lineHeight: '48px',
    fontFamily: 'Barlow',
  } as React.CSSProperties,
  HeadingXl: {
    fontSize: 44,
    lineHeight: '52px',
    fontFamily: 'Barlow',
  } as React.CSSProperties,
  HeadingXxl: {
    fontSize: 56,
    lineHeight: '68px',
    fontFamily: 'Barlow',
  } as React.CSSProperties,
};

export enum FontStyleEnums {
  BodyXsRegular = 'BodyXsRegular',
  BodyXsSemibold = 'BodyXsSemibold',
  BodySmRegular = 'BodySmRegular',
  BodySmSemibold = 'BodySmSemibold',
  BodyMdRegular = 'BodyMdRegular',
  BodyMdSemibold = 'BodyMdSemibold',
  BodyLgRegular = 'BodyLgRegular',
  BodyLgSemibold = 'BodyLgSemibold',
  BodyXlRegular = 'BodyXlRegular',
  BodyXlSemibold = 'BodyXlSemibold',
  HeadingXs = 'HeadingXs',
  HeadingSm = 'HeadingSm',
  HeadingMd = 'HeadingMd',
  HeadingLg = 'HeadingLg',
  HeadingXl = 'HeadingXl',
  HeadingXxl = 'HeadingXxl',
}

export type FontStyles = typeof typography;

export default typography;
